export const styles = theme => ({
    paper: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        marginLeft: 'auto',
        marginRight: 'auto',
        width: "70%",
        padding: `${theme.spacing.unit * 1}px ${theme.spacing.unit * 1}px ${theme.spacing.unit * 1}px`,
        [theme.breakpoints.up('md')]: {
            padding: `${theme.spacing.unit * 2}px ${theme.spacing.unit * 3}px ${theme.spacing.unit * 3}px`,
            width: "35%",
        },
    },
    itemPaper: {
        paddingTop: theme.spacing.unit * 1,
        paddingRight: theme.spacing.unit * 1,
        paddingLeft: theme.spacing.unit * 1,
        paddingBottom: theme.spacing.unit * 1,
        marginLeft: theme.spacing.unit * 1,
        marginRight: theme.spacing.unit * 1,
        marginBottom: theme.spacing.unit * 1,
    },
    modalDialog: theme.dialogDimentions,
    addressList: {
        padding: '0px',
        ...theme.listContainer,
    },
    addDialogFabButton: {
        position: 'fixed',
        bottom: 20,
        right: 20,
        [theme.breakpoints.up('md')]: {
            display: 'none'
        }
    },
    buttonCard: {
        alignSelf: 'self-start',
        boxShadow: theme.shadows[2],
        borderRadius: '50%',
        paddingBottom: '0px',
        paddingTop: '0px',
        paddingLeft: 0,
        display: 'block',
        zIndex: 0,
        overflow: 'hidden',
    },
    emptyTypography: {
        fontSize: 14,
        marginTop: '20px',
        color: 'rgba(0, 0, 0, 0.40)',
    },
    dialogContent: {
        padding: 20,
        '& .addressInput': {
            marginTop: 30,
        },
        [theme.breakpoints.up('sm')]: {
            padding: 30,
        }
    },
    closeModalButton: {
        position: 'absolute',
        right: 10,
        top: 10,
        [theme.breakpoints.up('md')]: {
            display: 'none'
        }
    },
    titleContainer: {
        borderBottom: 'solid 1px #D2D0D0',
        display: 'flex',
        alignItems: 'center',
        minHeight: '30px',
    },
    dialogTitle: {
        flexGrow: 1,
        fontSize: '15px',
        lineHeight: 'inherit',
    },
    itemDiv: {
        display: 'flex',
        padding: '20px',
        backgroundColor: 'white',
        cursor: 'pointer'
    },
});
